import { Flex, Text, Box } from '@chakra-ui/core'
import React from 'react'

interface SettingItemProps {
  number: number
  title: string
  description?: string
  control: React.ReactNode
  isDisabled?: boolean
  additionalContent?: React.ReactNode
}

export const SettingItem: React.FC<SettingItemProps> = ({
  number,
  title,
  description,
  control,
  isDisabled,
  additionalContent,
}) => {
  return (
    <Box
      bg="white"
      borderRadius="10px"
      p="20px"
      border="1px solid #E2E8F0"
      pointerEvents={isDisabled ? 'none' : 'all'}
      opacity={isDisabled ? 0.5 : 1}
    >
      <Flex alignItems="center" justifyContent="space-between" style={{ columnGap: '50px' }}>
        <Flex alignItems="flex-start" style={{ columnGap: '16px' }}>
          <Text fontSize="16px" fontWeight="600" color="#1E293B" minW="24px" dir="ltr">
            {number}.
          </Text>
          <Flex flexDir="column" style={{ rowGap: '4px' }}>
            <Text fontSize="14px" fontWeight="600" color="#1E293B">
              {title}
            </Text>
            {description && (
              <Text fontSize="12px" color="#64748B" lineHeight="1.5">
                {description}
              </Text>
            )}
          </Flex>
        </Flex>
        {additionalContent && (
          <Flex flex={1} mx="16px" justifyContent="center">
            {additionalContent}
          </Flex>
        )}
        <Box>{control}</Box>
      </Flex>
    </Box>
  )
}
